(function () {

  const EXTRAS_VARIANTS = {
    "no - just we will leave after the art portion|up to 8 people (base price)|no - watercolour paper is fine": 42479493021786,
    "no - just we will leave after the art portion|up to 8 people (base price)|yes please! ($6/pp)": 42479514517594,
    "no - just we will leave after the art portion|9 people|no - watercolour paper is fine": 42479493054554,
    "no - just we will leave after the art portion|9 people|yes please! ($6/pp)": 42479514550362,
    "no - just we will leave after the art portion|10 people|no - watercolour paper is fine": 42479493087322,
    "no - just we will leave after the art portion|10 people|yes please! ($6/pp)": 42479514583130,
    "no - just we will leave after the art portion|11 people|no - watercolour paper is fine": 42479493120090,
    "no - just we will leave after the art portion|11 people|yes please! ($6/pp)": 42479514615898,
    "no - just we will leave after the art portion|12 people|no - watercolour paper is fine": 42479493152858,
    "no - just we will leave after the art portion|12 people|yes please! ($6/pp)": 42479514648666,
    "no - just we will leave after the art portion|13 people|no - watercolour paper is fine": 42479493185626,
    "no - just we will leave after the art portion|13 people|yes please! ($6/pp)": 42479514681434,
    "no - just we will leave after the art portion|14 people|no - watercolour paper is fine": 42479493218394,
    "no - just we will leave after the art portion|14 people|yes please! ($6/pp)": 42479514714202,
    "no - just we will leave after the art portion|15 people|no - watercolour paper is fine": 42479493251162,
    "no - just we will leave after the art portion|15 people|yes please! ($6/pp)": 42479514746970,
    "no - just we will leave after the art portion|16 people|no - watercolour paper is fine": 42479493283930,
    "no - just we will leave after the art portion|16 people|yes please! ($6/pp)": 42479514779738,
    "no - just we will leave after the art portion|17 people|no - watercolour paper is fine": 42479493316698,
    "no - just we will leave after the art portion|17 people|yes please! ($6/pp)": 42479514812506,
    "no - just we will leave after the art portion|18 people|no - watercolour paper is fine": 42479493349466,
    "no - just we will leave after the art portion|18 people|yes please! ($6/pp)": 42479514845274,
    "no - just we will leave after the art portion|19 people|no - watercolour paper is fine": 42479493382234,
    "no - just we will leave after the art portion|19 people|yes please! ($6/pp)": 42479514878042,
    "no - just we will leave after the art portion|20 people|no - watercolour paper is fine": 42479493415002,
    "no - just we will leave after the art portion|20 people|yes please! ($6/pp)": 42479514910810,
    "yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)|no - watercolour paper is fine": 42479493447770,
    "yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)|yes please! ($6/pp)": 42479514943578,
    "yes - add 30 minutes (enough time for cake only)|9 people|no - watercolour paper is fine": 42479493480538,
    "yes - add 30 minutes (enough time for cake only)|9 people|yes please! ($6/pp)": 42479514976346,
    "yes - add 30 minutes (enough time for cake only)|10 people|no - watercolour paper is fine": 42479493513306,
    "yes - add 30 minutes (enough time for cake only)|10 people|yes please! ($6/pp)": 42479515009114,
    "yes - add 30 minutes (enough time for cake only)|11 people|no - watercolour paper is fine": 42479493546074,
    "yes - add 30 minutes (enough time for cake only)|11 people|yes please! ($6/pp)": 42479515041882,
    "yes - add 30 minutes (enough time for cake only)|12 people|no - watercolour paper is fine": 42479493578842,
    "yes - add 30 minutes (enough time for cake only)|12 people|yes please! ($6/pp)": 42479515074650,
    "yes - add 30 minutes (enough time for cake only)|13 people|no - watercolour paper is fine": 42479493611610,
    "yes - add 30 minutes (enough time for cake only)|13 people|yes please! ($6/pp)": 42479515107418,
    "yes - add 30 minutes (enough time for cake only)|14 people|no - watercolour paper is fine": 42479493644378,
    "yes - add 30 minutes (enough time for cake only)|14 people|yes please! ($6/pp)": 42479515140186,
    "yes - add 30 minutes (enough time for cake only)|15 people|no - watercolour paper is fine": 42479493677146,
    "yes - add 30 minutes (enough time for cake only)|15 people|yes please! ($6/pp)": 42479515172954,
    "yes - add 30 minutes (enough time for cake only)|16 people|no - watercolour paper is fine": 42479493709914,
    "yes - add 30 minutes (enough time for cake only)|16 people|yes please! ($6/pp)": 42479515205722,
    "yes - add 30 minutes (enough time for cake only)|17 people|no - watercolour paper is fine": 42479493742682,
    "yes - add 30 minutes (enough time for cake only)|17 people|yes please! ($6/pp)": 42479515238490,
    "yes - add 30 minutes (enough time for cake only)|18 people|no - watercolour paper is fine": 42479493775450,
    "yes - add 30 minutes (enough time for cake only)|18 people|yes please! ($6/pp)": 42479515271258,
    "yes - add 30 minutes (enough time for cake only)|19 people|no - watercolour paper is fine": 42479493808218,
    "yes - add 30 minutes (enough time for cake only)|19 people|yes please! ($6/pp)": 42479515304026,
    "yes - add 30 minutes (enough time for cake only)|20 people|no - watercolour paper is fine": 42479493840986,
    "yes - add 30 minutes (enough time for cake only)|20 people|yes please! ($6/pp)": 42479515336794,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)|no - watercolour paper is fine": 42479493873754,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)|yes please! ($6/pp)": 42479515369562,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people|no - watercolour paper is fine": 42479493906522,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people|yes please! ($6/pp)": 42479515402330,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people|no - watercolour paper is fine": 42479493939290,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people|yes please! ($6/pp)": 42479515435098,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people|no - watercolour paper is fine": 42479493972058,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people|yes please! ($6/pp)": 42479515467866,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people|no - watercolour paper is fine": 42479494004826,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people|yes please! ($6/pp)": 42479515500634,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people|no - watercolour paper is fine": 42479494037594,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people|yes please! ($6/pp)": 42479515533402,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people|no - watercolour paper is fine": 42479494070362,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people|yes please! ($6/pp)": 42479515566170,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people|no - watercolour paper is fine": 42479494103130,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people|yes please! ($6/pp)": 42479515598938,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people|no - watercolour paper is fine": 42479494135898,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people|yes please! ($6/pp)": 42479515631706,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people|no - watercolour paper is fine": 42479494168666,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people|yes please! ($6/pp)": 42479515664474,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people|no - watercolour paper is fine": 42479494201434,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people|yes please! ($6/pp)": 42479515697242,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people|no - watercolour paper is fine": 42479494234202,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people|yes please! ($6/pp)": 42479515730010,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people|no - watercolour paper is fine": 42479494266970,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people|yes please! ($6/pp)": 42479515762778,
  };

  const EXTRAS_PRICES = {
    "no - just we will leave after the art portion|up to 8 people (base price)|no - watercolour paper is fine": 0,
    "no - just we will leave after the art portion|up to 8 people (base price)|yes please! ($6/pp)": 4800,
    "no - just we will leave after the art portion|9 people|no - watercolour paper is fine": 1600,
    "no - just we will leave after the art portion|9 people|yes please! ($6/pp)": 7000,
    "no - just we will leave after the art portion|10 people|no - watercolour paper is fine": 3200,
    "no - just we will leave after the art portion|10 people|yes please! ($6/pp)": 9200,
    "no - just we will leave after the art portion|11 people|no - watercolour paper is fine": 4800,
    "no - just we will leave after the art portion|11 people|yes please! ($6/pp)": 11400,
    "no - just we will leave after the art portion|12 people|no - watercolour paper is fine": 6400,
    "no - just we will leave after the art portion|12 people|yes please! ($6/pp)": 13600,
    "no - just we will leave after the art portion|13 people|no - watercolour paper is fine": 8000,
    "no - just we will leave after the art portion|13 people|yes please! ($6/pp)": 15800,
    "no - just we will leave after the art portion|14 people|no - watercolour paper is fine": 9600,
    "no - just we will leave after the art portion|14 people|yes please! ($6/pp)": 18000,
    "no - just we will leave after the art portion|15 people|no - watercolour paper is fine": 11200,
    "no - just we will leave after the art portion|15 people|yes please! ($6/pp)": 20200,
    "no - just we will leave after the art portion|16 people|no - watercolour paper is fine": 16800,
    "no - just we will leave after the art portion|16 people|yes please! ($6/pp)": 26400,
    "no - just we will leave after the art portion|17 people|no - watercolour paper is fine": 18400,
    "no - just we will leave after the art portion|17 people|yes please! ($6/pp)": 28600,
    "no - just we will leave after the art portion|18 people|no - watercolour paper is fine": 20000,
    "no - just we will leave after the art portion|18 people|yes please! ($6/pp)": 30800,
    "no - just we will leave after the art portion|19 people|no - watercolour paper is fine": 21600,
    "no - just we will leave after the art portion|19 people|yes please! ($6/pp)": 33000,
    "no - just we will leave after the art portion|20 people|no - watercolour paper is fine": 23200,
    "no - just we will leave after the art portion|20 people|yes please! ($6/pp)": 35200,
    "yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)|no - watercolour paper is fine": 6400,
    "yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)|yes please! ($6/pp)": 11200,
    "yes - add 30 minutes (enough time for cake only)|9 people|no - watercolour paper is fine": 8800,
    "yes - add 30 minutes (enough time for cake only)|9 people|yes please! ($6/pp)": 14200,
    "yes - add 30 minutes (enough time for cake only)|10 people|no - watercolour paper is fine": 11200,
    "yes - add 30 minutes (enough time for cake only)|10 people|yes please! ($6/pp)": 17200,
    "yes - add 30 minutes (enough time for cake only)|11 people|no - watercolour paper is fine": 13600,
    "yes - add 30 minutes (enough time for cake only)|11 people|yes please! ($6/pp)": 20200,
    "yes - add 30 minutes (enough time for cake only)|12 people|no - watercolour paper is fine": 16000,
    "yes - add 30 minutes (enough time for cake only)|12 people|yes please! ($6/pp)": 23200,
    "yes - add 30 minutes (enough time for cake only)|13 people|no - watercolour paper is fine": 18400,
    "yes - add 30 minutes (enough time for cake only)|13 people|yes please! ($6/pp)": 26200,
    "yes - add 30 minutes (enough time for cake only)|14 people|no - watercolour paper is fine": 20800,
    "yes - add 30 minutes (enough time for cake only)|14 people|yes please! ($6/pp)": 29200,
    "yes - add 30 minutes (enough time for cake only)|15 people|no - watercolour paper is fine": 23200,
    "yes - add 30 minutes (enough time for cake only)|15 people|yes please! ($6/pp)": 32200,
    "yes - add 30 minutes (enough time for cake only)|16 people|no - watercolour paper is fine": 29600,
    "yes - add 30 minutes (enough time for cake only)|16 people|yes please! ($6/pp)": 39200,
    "yes - add 30 minutes (enough time for cake only)|17 people|no - watercolour paper is fine": 32000,
    "yes - add 30 minutes (enough time for cake only)|17 people|yes please! ($6/pp)": 42200,
    "yes - add 30 minutes (enough time for cake only)|18 people|no - watercolour paper is fine": 34400,
    "yes - add 30 minutes (enough time for cake only)|18 people|yes please! ($6/pp)": 45200,
    "yes - add 30 minutes (enough time for cake only)|19 people|no - watercolour paper is fine": 36800,
    "yes - add 30 minutes (enough time for cake only)|19 people|yes please! ($6/pp)": 48200,
    "yes - add 30 minutes (enough time for cake only)|20 people|no - watercolour paper is fine": 39200,
    "yes - add 30 minutes (enough time for cake only)|20 people|yes please! ($6/pp)": 51200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)|no - watercolour paper is fine": 9600,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)|yes please! ($6/pp)": 14400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people|no - watercolour paper is fine": 12400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people|yes please! ($6/pp)": 17800,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people|no - watercolour paper is fine": 15200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people|yes please! ($6/pp)": 21200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people|no - watercolour paper is fine": 18000,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people|yes please! ($6/pp)": 24600,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people|no - watercolour paper is fine": 20800,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people|yes please! ($6/pp)": 28000,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people|no - watercolour paper is fine": 23600,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people|yes please! ($6/pp)": 31400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people|no - watercolour paper is fine": 26400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people|yes please! ($6/pp)": 34800,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people|no - watercolour paper is fine": 29200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people|yes please! ($6/pp)": 38200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people|no - watercolour paper is fine": 36000,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people|yes please! ($6/pp)": 45600,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people|no - watercolour paper is fine": 38800,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people|yes please! ($6/pp)": 49000,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people|no - watercolour paper is fine": 41600,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people|yes please! ($6/pp)": 52400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people|no - watercolour paper is fine": 44400,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people|yes please! ($6/pp)": 55800,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people|no - watercolour paper is fine": 47200,
    "yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people|yes please! ($6/pp)": 59200,
  };

  const BASE_EXTRAS_KEY    = "no - just we will leave after the art portion|up to 8 people (base price)|no - watercolour paper is fine";
  const PARENT_STAY_HANDLE = 'kids-party-parent-helper-observer';

  const STUDIO_MAX = {
    'VANCOUVER - MAIN STREET': 12,
    'VICTORIA - UPTOWN': 20,
    'BURLINGTON - SOUTH': 20,
    'CAMBRIDGE - GALT': 15,
    'KINGSTON - ARLINGTON PARK': 15,
    'LONDON - BYRON': 12,
    'MISSISSAUGA - PORT CREDIT': 20,
    'TORONTO - THE BEACHES': 12,
  };

  let parentStayVariantId  = null;
  let parentStayPriceCents = 500;

  async function loadParentStayVariant() {
    try {
      const res     = await fetch('/products/' + PARENT_STAY_HANDLE + '.js');
      const product = await res.json();
      if (product.variants && product.variants.length > 0) {
        parentStayVariantId  = product.variants[0].id;
        parentStayPriceCents = product.variants[0].price;
      }
    } catch (err) {
      console.error('Parent stay lookup error:', err);
    }
  }

  function getParticipantCount(val) {
    if (!val || val.startsWith('up to 8')) return 8;
    const m = val.match(/^(\d+)/);
    return m ? parseInt(m[1]) : 8;
  }

  function maxFromValue(val) {
    if (val === 'up to 8 people (base price)') return 8;
    return parseInt(val);
  }

  function getStudioSelect() {
    return document.querySelector('select[id^="product-select-studio-"]');
  }

  function getSelectedStudioTitle() {
    const sel = getStudioSelect();
    return sel ? sel.value.trim() : null;
  }

  function filterParticipants(participSel) {
    const studioTitle = getSelectedStudioTitle();
    const max = (studioTitle && STUDIO_MAX[studioTitle]) || 20;
    Array.from(participSel.options).forEach(opt => {
      const optMax = maxFromValue(opt.value);
      opt.hidden   = optMax > max;
      opt.disabled = optMax > max;
    });
    if (maxFromValue(participSel.value) > max) {
      const firstVisible = Array.from(participSel.options).find(o => !o.hidden);
      if (firstVisible) participSel.value = firstVisible.value;
    }
  }

  function init() {
    const block = document.getElementById('splatter-addons-block');
    if (!block) return;

    const partyAfterSel      = document.getElementById('splatter-time-after');
    const participSel        = document.getElementById('splatter-participants');
    const canvasSel          = document.getElementById('splatter-canvas');
    const errorEl            = document.getElementById('splatter-error');
    const subtotalBase       = document.getElementById('splatter-subtotal-base');
    const extrasRow          = document.getElementById('splatter-extras-row');
    const subtotalExtras     = document.getElementById('splatter-subtotal-extras');
    const parentStayRow      = document.getElementById('splatter-parent-stay-row');
    const subtotalParent     = document.getElementById('splatter-subtotal-parent-stay');
    const subtotalTotal      = document.getElementById('splatter-subtotal-total');
    const basePriceCents     = parseInt(block.dataset.basePrice) || 0;

    const parentStayYes = document.getElementById('splatter-parent-stay-yes');
    const hasParentStay = !!parentStayYes;

    if (hasParentStay) loadParentStayVariant();

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function extrasKey() {
      return `${partyAfterSel.value}|${participSel.value}|${canvasSel.value}`;
    }

    function getParentStayChoice() {
      if (!hasParentStay) return 'no';
      const checked = document.querySelector('input[name="splatter-parent-stay"]:checked');
      return checked ? checked.value : 'no';
    }

    function updateUI() {
      const key         = extrasKey();
      const extrasCents = EXTRAS_PRICES[key] ?? 0;
      const parentYes   = getParentStayChoice() === 'yes';
      const count       = getParticipantCount(participSel.value);
      const parentCents = parentYes ? parentStayPriceCents * (count - 1) : 0;

      subtotalBase.textContent       = fmt(basePriceCents);
      extrasRow.style.display        = extrasCents > 0 ? 'flex' : 'none';
      subtotalExtras.textContent     = fmt(extrasCents);

      if (parentStayRow) {
        parentStayRow.style.display  = parentYes ? 'flex' : 'none';
        if (subtotalParent) {
          subtotalParent.textContent = fmt(parentCents) + ' (' + (count - 1) + ' \u00d7 ' + fmt(parentStayPriceCents) + ')';
        }
      }

      subtotalTotal.textContent = fmt(basePriceCents + extrasCents + parentCents);
    }

    filterParticipants(participSel);

    const studioSelect = getStudioSelect();
    if (studioSelect) {
      studioSelect.addEventListener('change', () => {
        filterParticipants(participSel);
        updateUI();
      });
    }

    document.addEventListener('variant:changed', () => {
      filterParticipants(participSel);
      updateUI();
    });

    [partyAfterSel, participSel, canvasSel].forEach(el => {
      el.addEventListener('change', updateUI);
    });

    if (hasParentStay) {
      document.querySelectorAll('input[name="splatter-parent-stay"]').forEach(r => {
        r.addEventListener('change', updateUI);
      });
    }

    updateUI();

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      errorEl.style.display = 'none';
      errorEl.textContent   = '';

      // Validate: observer policy checkbox
      const acknowledgeBox = document.getElementById('splatter-observer-acknowledge');
      if (acknowledgeBox && !acknowledgeBox.checked) {
        errorEl.textContent = 'Please confirm you have read and understood the adult observer policy before adding to cart.';
        errorEl.style.display = 'block';
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      const baseVariantId = form.querySelector('[name="id"]')?.value;
      if (!baseVariantId) {
        errorEl.textContent = 'Could not determine party variant. Please refresh and try again.';
        errorEl.style.display = 'block';
        return;
      }

      const linkedTo = String(baseVariantId);
      const items    = [];

      // 1. Main party booking
      items.push({ id: parseInt(baseVariantId), quantity: 1 });

      // 2. Extras add-on — linked to base
      const key = extrasKey();
      if (key !== BASE_EXTRAS_KEY) {
        const extrasId = EXTRAS_VARIANTS[key];
        if (extrasId) {
          items.push({
            id: extrasId,
            quantity: 1,
            properties: { '_linked_to': linkedTo }
          });
        }
      }

      // 3. Parent stay add-on — linked to base
      if (hasParentStay && getParentStayChoice() === 'yes') {
        if (!parentStayVariantId) await loadParentStayVariant();
        if (parentStayVariantId) {
          const count = getParticipantCount(participSel.value);
          items.push({
            id: parentStayVariantId,
            quantity: count - 1,
            properties: { '_linked_to': linkedTo }
          });
        }
      }

      try {
        const res  = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await res.json();

        if (!res.ok) {
          errorEl.textContent = data.description || 'There was a problem adding to cart. Please try again.';
          errorEl.style.display = 'block';
          return;
        }

        if (window.miniMakeUpsell && window.miniMakeUpsell.pendingShow) {
          window.miniMakeUpsell.pendingShow();
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        errorEl.textContent = 'Network error. Please check your connection and try again.';
        errorEl.style.display = 'block';
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();